import { render, staticRenderFns } from "./SecondBox.vue?vue&type=template&id=7ca0422a&"
import script from "./SecondBox.vue?vue&type=script&lang=js&"
export * from "./SecondBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports